export const UEC_SUBJECTS = [
  {
    label: "Chinese",
    value: "Chinese",
  },
  {
    label: "Maths",
    value: "Mathematics",
  },
  {
    label: "Biology",
    value: "Biology",
  },
  {
    label: "Chemistry",
    value: "Chemistry",
  },
  {
    label: "Physics",
    value: "Physics",
  },
  {
    label: "Accounting",
    value: "Bookkeeping",
  },
  {
    label: "English",
    value: "English",
  },
  {
    label: "Add Maths",
    value: "Additional Mathematics",
  },
];

export const SPM_SUBJECTS = [
  {
    label: "Malay",
    value: "Bahasa Melayu",
  },
  {
    label: "English",
    value: "English",
  },
  {
    label: "Sejarah",
    value: "Sejarah",
  },
  {
    label: "Maths",
    value: "Mathematics",
  },
  {
    label: "Add Maths",
    value: "Additional Mathematics",
  },
  {
    label: "Chemistry",
    value: "Chemistry",
  },
  {
    label: "Physics",
    value: "Physics",
  },
];
